import { influencer } from '@round/api';
import { Button, Skeleton, Tooltip, lucideIcons, tableHelpers } from '@round/creatorbase-ui';
import { CellContext, getCreatorName } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';
import { getTableMeta } from '../../helpers';
import styles from './RemoveFromSelectionCell.module.css';

const { Check, X } = lucideIcons;

const ADDED_LABEL = 'Already in this pool';

type Props = CellContext & {
    onRemove: (creator: influencer.CreatorSearchResult) => void;
    isDisabled: boolean;
};

export const RemoveFromSelectionCell = ({ row: { original }, table, onRemove, isDisabled }: Props) => {
    const { getCreatorPoolAccounts } = getTableMeta(table);

    if (tableHelpers.isLoadingRow(original)) {
        return <Skeleton className={styles.skeleton} />;
    }

    const { accountIdsToAdd } = getCreatorPoolAccounts(original);

    return (
        <div className={styles.actions}>
            <Button
                size="icon-sm"
                variant="ghost"
                disabled={isDisabled}
                onClick={() => onRemove(original)}
                aria-label={`Remove ${getCreatorName(original)} from the selection`}
            >
                <X />
            </Button>

            {accountIdsToAdd.length ? null : (
                <Tooltip>
                    <Tooltip.Trigger className={styles.added} aria-label={ADDED_LABEL}>
                        <Check className={styles.addedIcon} />
                    </Tooltip.Trigger>
                    <Tooltip.Content>{ADDED_LABEL}</Tooltip.Content>
                </Tooltip>
            )}
        </div>
    );
};
